const actions = ['SET_QUERY']

const subActions = {}

export default [actions, subActions]
